"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useFieldContext = _interopRequireDefault(require("./useFieldContext"));
var _useFormContext = _interopRequireDefault(require("./useFormContext"));
var _useTheme = _interopRequireDefault(require("../../../hooks/useTheme"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var useInputLogic = function useInputLogic(props) {
  var defaultValue = props.defaultValue,
    disabled = props.disabled,
    name = props.name;
  var theme = (0, _useTheme.default)();
  var _a = (0, _useFormContext.default)(),
    clearValidationMessages = _a.clearValidationMessages,
    formDisabled = _a.disabled,
    formData = _a.formData,
    getFieldValue = _a.getFieldValue,
    getHighestValidationMessageType = _a.getHighestValidationMessageType,
    isActing = _a.isActing,
    setFieldValue = _a.setFieldValue;
  var _b = (0, _useFieldContext.default)(),
    additionalInputProps = _b.additionalInputProps,
    fieldName = _b.fieldName,
    initialize = _b.initialize,
    setFieldName = _b.setFieldName,
    terminate = _b.terminate,
    validate = _b.validate;
  (0, _react.useEffect)(function () {
    if (name !== fieldName) {
      setFieldName(name);
    }
  }, [fieldName, name, setFieldName]);
  // separate initialize and terminate to avoid unwanted additional executions
  (0, _react.useEffect)(function () {
    initialize(name, defaultValue);
  }, [defaultValue, initialize, name]);
  (0, _react.useEffect)(function () {
    return function () {
      terminate(name);
    };
  }, [terminate, name]);
  var onBlur = (0, _react.useCallback)(function () {
    clearValidationMessages(name, "all");
    validate();
  }, [clearValidationMessages, name, validate]);
  var validateOnChange = (0, _react.useCallback)(function (fieldName, fieldValue) {
    var _a;
    var updatedFormData = __assign(__assign({}, formData), (_a = {}, _a[fieldName] = __assign(__assign({}, formData[fieldName]), {
      value: fieldValue
    }), _a));
    validate(updatedFormData, true);
  }, [formData, validate]);
  return {
    additionalInputProps: additionalInputProps || {},
    clearValidationMessages: clearValidationMessages,
    disabled: Boolean(formDisabled || isActing || disabled),
    getFieldValue: getFieldValue,
    onBlur: onBlur,
    setFieldValue: setFieldValue,
    theme: theme,
    validateOnChange: validateOnChange,
    validationType: getHighestValidationMessageType(name),
    value: getFieldValue(name)
  };
};
var _default = useInputLogic;
exports.default = _default;